import styled from "styled-components"

const Layout = styled.div`
   display: flex;
   min-height: 100vh;
   background: #fff;
`;

const Main = styled.main`
   flex: 1;
   display: flex;
   margin-left: 230px;
   flex-direction: column;
`;

const TopBar = styled.header`
   height: 64px;
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 0 40px;
   border-bottom: 1px solid #F0F0F2;
   position: sticky;
   top: 0;
   z-index: 10;
   background-color: white;
`;

const UserRole = styled.span`
   font-size: 10px;
   letter-spacing: -0.02em;
   color: #C02236;
   padding: 4px 8px;
   border-radius: 99px;
   width: min-content;
   background: rgba(192, 34, 54, 0.08);
   font-family: ui-monospace, "SF Mono", monospace;
`;

const Content = styled.div`
   flex: 1;
   padding: 40px 40px 60px;
`;

const Heading = styled.h1`
   font-size: 23px;
   font-weight: 600;
   margin: 0 0 4px;
   color: #101018;
`;
const HeadingSub = styled.p`
   font-size: 14px;
   color: #B3B3B6;
   letter-spacing: -0.025em;
   margin: 0 0 32px;
`;

const CardsGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(240px,1fr));
   gap: 20px;
   margin-bottom: 48px;
`;

const Card = styled.div`
   background: #fff;
   border: 1px solid #E7E7E9;
   border-radius: 12px;
   padding: 16px 18px 16px 18px;
   display: flex;
   flex-direction: column;
   gap: 6px;
`;

const StatTitle = styled.span`
   font-size: 14px;
   font-weight: 500;
   letter-spacing: -0.025em;
   color: rgba(16,16,24,0.4);
`;
const StatValue = styled.div`
   font-size: 32px;
   font-weight: 600;
   align-self: stretch;
   letter-spacing: -0.025em;
   color: #101018;
`;
const StatMetaRow = styled.div`
   display: flex;
   align-items: center;
   gap: 6px;
   font-size: 10px;
`;

interface MonoProps { changePositive?: boolean }

const Mono = styled.span<MonoProps>`
   padding: 3px 6px 3px 4px;
   justify-content: center;
   align-items: center;
   display: inline-flex;
   gap: 2px;
   border-radius: 99px;
   color: ${({ changePositive }) =>
      changePositive === undefined ? '#9C9C9F' :
      changePositive ? '#1BB833' : '#D93025'
   };
   background: ${({ changePositive }) =>
      changePositive === undefined ? 'rgba(156, 156, 159, 0.08)' :
      changePositive ? 'rgba(27, 184, 51, 0.08)' : 'rgba(221, 82, 77, 0.08)'
   };

   & span {
      font-size: 10px;
      font-weight: 500;
      margin-top: 0.5px;
      font-family: ui-monospace, "SF Mono", monospace;
   }
`;

interface MetaProps { change?: boolean, link?: boolean }

const MetaMuted = styled.span<MetaProps>`
   font-size: 12px;
   letter-spacing: -0.025em;
   color: ${({ change }) => (change ? 'rgba(179, 179, 182, 0.80)' : '#9C9C9F')};
   
   ${({ link }) => link && `
      &:hover {
         cursor: pointer;
         text-decoration: underline;
      }
   `}
`;

export {
   Layout,
   Main,
   TopBar,
   UserRole,
   Content,
   Heading,
   HeadingSub,
   CardsGrid,
   Card,
   StatTitle,
   StatValue,
   StatMetaRow,
   Mono,
   MetaMuted
};
